<template>
  <div class="login_box">
    <!-- <img src="../../../assets/jsdw.png" alt=""> -->
    <el-row
      :span="24"
      v-on:keyup.native.enter="submit"
      type="flex"
      justify="center"
    >
      <el-col
        :span="24"
        style="margin-top:5%"
      >
        <div class="constractor_top" style="margin: 50px;font-size: 16px;">
          <h1>苏 </nbsp>州 </nbsp>数 </nbsp>字 </nbsp>化 </nbsp>审 </nbsp>图 </nbsp>系 </nbsp>统</h1>
        </div>
        <div style="display: flex;width:100%; "> 
          <div style="display: flex;width:50%;justify-content: right;align-items: right;"
          v-show="loginAccount"
        >
              <img
                src="../../../assets/img.png"
                alt=""
                style="width:432px; height:440px;"
              />
        </div>
          <div
          class="login"
          v-show="loginAccount" 
          style="float:left;"
        >
          <h1 style="margin-bottom: 20px;color: rgb(101 103 105);font-size: 22px;">{{ title }}</h1>
          <el-form
            ref="loginRef"
            :model="login"
            :rules="rules"
          >
            <el-form-item prop="username">
              <img
                src="../../../assets/icon-user.png"
                alt=""
                class="username_position"
              />
              <el-input
                placeholder="组织机构代码"
                v-model="login.username"
                class="directive_input_style"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <img
                src="../../../assets/icon-code.png"
                alt=""
                class="username_position"
              />
              <el-input
                type="password"
                placeholder="密码"
                v-model="login.password"
                class="directive_input_style"
              ></el-input>
            </el-form-item>
            <el-form-item prop="verification">
              <img
                src="../../../assets/icon-verification_code.png"
                alt=""
                class="username_position"
                width="32px"
              />
              <el-input
                type="verification"
                placeholder="验证码"
                v-model="login.verification"
                class="directive_input_style"
                style="width:160px;float:left;height:30px;line-height:30px"
              ></el-input>
              <div
                class="code"
                @click="refreshCode"
              >
                <!-- {{identifyCode}} -->
                <identify :identifyCode="identifyCode"></identify>
              </div>
              <el-button
                icon="el-icon-refresh"
                type="text"
                style="margin-top: -44px;font-size: 22px;position: absolute;margin-left: 110px;"
                @click="refreshCode"
              ></el-button>
              <!-- <el-button type="text" style="float:right;margin-top:-44px；font-size:12px" size="mini" @click="refreshCode">点击换一张</el-button> -->
            </el-form-item>
            <el-form-item>
              <el-row>
                <el-col
                  :span="11"
                  style="text-align: left;"
                >
                  <el-button
                    type="text"
                    @click="register()"
                    style="color: #8F8F8F;text-decoration:underline"
                  ><img
                      src=""
                      alt=""
                      style="width: 20%;vertical-align: middle;"
                    />
                    点击注册
                  </el-button>
                </el-col>
                <el-col
                  :span="13"
                  style="text-align:right"
                >
                  <el-button
                    type="text"
                    @click="show_reset_password"
                    style="color: #8F8F8F;"
                  ><img
                      src=""
                      alt=""
                      style="width: 20%;vertical-align: middle;"
                    />
                    修改密码
                  </el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-button
                    type="primary"
                    style="width: 100%"
                    v-loading.fullscreen.lock="loading"
                    @click="submit"
                  >登录</el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-button
                    type="text"
                    @click="guidance"
                  >办事指南</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button
                    type="text"
                    @click="question"
                  >常见问题</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button
                    type="text"
                    @click="video"
                  >参考视频</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button
                    type="text"
                    @click="handbook"
                  >参照手册</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
        </div>
       
        <div
          v-show="CA"
          class="login"
        >
          <el-form
            ref="loginRef"
            :model="login"
            :rules="rules"
          >
            <div style="height:150px;padding-top:50px;font-size:18px;color:#409EFF">
              请插入UKEY证书,点击登录
              <OBJECT
                id="obj"
                ref="obj"
                name="obj"
                classid="CLSID:093EA822-9C5D-4D46-883E-3421A93DCCF8"
                codebase="FJCAApi.ocx"
                style="LEFT: 0px; TOP: 0px"
                height="12"
                width="12"
              ></OBJECT>
            </div>
            <el-form-item>
              <el-row>
                <el-col
                  :span="11"
                  style="text-align: left;"
                >
                  <el-button
                    type="text"
                    @click="register()"
                    style="color: #8F8F8F;text-decoration:underline"
                  ><img
                      src=""
                      alt=""
                      style="width: 20%;vertical-align: middle;"
                    />
                    点击注册
                  </el-button>
                </el-col>
                <el-col
                  :span="13"
                  style="text-align:right"
                >
                  <el-button
                    type="text"
                    @click="show_reset_password"
                    style="color: #8F8F8F;"
                  ><img
                      src=""
                      alt=""
                      style="width: 20%;vertical-align: middle;"
                    />
                    忘记密码
                  </el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-button
                    type="primary"
                    style="width: 100%"
                    v-loading.fullscreen.lock="loading"
                    @click="submit_ca"
                  >登录</el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-row>
                <el-col :span="6">
                  <el-button
                    type="text"
                    @click="guidance"
                  >办事指南</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button
                    type="text"
                    @click="question"
                  >常见问题</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button
                    type="text"
                    @click="video"
                  >参考视频</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button
                    type="text"
                    @click="handbook"
                  >参照手册</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
        <div class="tabclass">
          <!-- <div class="rilogin loginrev" @click="accountlogin" ref="yonghu">用户名登录</div> -->
          <!-- <div class="lelogin loginrev" @click="CAlogin" ref="ca">CA登录</div> -->
        </div>
        <div style="height:130px;margin: 0 auto;padding-top:100px;color: #282C37;    position: relative;text-alignt:bottom;">
          <p>苏州市住房和城乡建设局</p>
        </div>
      </el-col>
    </el-row>
    <!-- <div class="login_l_img" ><el-row style="margin-top: 55px"><el-button  style="font-size:20px" round>办事指南</el-button><el-button style="font-size: 20px" round>常见问题</el-button></el-row>
      <el-row style="margin-top: 30px"><el-button  style="font-size: 20px" round>参考视频</el-button><el-button  style="font-size:20px" round>操作手册</el-button></el-row>
    </div> -->
    <!-- 修改密码 -->
    <el-dialog
      :title="reset.title"
      :visible.sync="reset.visible"
      :before-close="reset_close"
    >
      <el-form
        label-width="120px"
        label-position="right"
        ref="resetRef"
        :model="reset.data"
        :rules="reset.rules"
        class="demo-form-inline"
      >
        <el-row>
          <el-col>
            <el-form-item
              label="组织机构代码："
              prop="organizationCode"
            >
              <el-input
                placeholder="组织机构代码"
                v-model="reset.data.organizationCode"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="手机号码:"
              prop="phone"
            >
              <el-input
                v-model="reset.data.contactPersonTel"
                :disabled="mon_count"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item
            label="验证码:"
            prop="verificationCode"
          >
            <el-col :span="18">
              <el-input v-model="reset.data.verificationCode"></el-input>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                :disabled="regphone || mon_count"
                @click="auth_code"
              >{{ mon_count ? count_down + "s" : "获取验证码" }}</el-button>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="新密码:"
              prop="passwd"
            >
              <el-input
                type="password"
                v-model="reset.data.password"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="确认密码:"
              prop="checkPass"
            >
              <el-input
                type="password"
                v-model="reset.checkpassword"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="20">
          <el-col :span="20">
            <el-form-item>
              <el-button
                type="primary"
                @click="reset_submit"
              >保 存</el-button>
              <el-button @click="reset_close">取 消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
// import identify from "../../store/identify.vue";
import identify from "../../../store/identify";
import cryptoObj from "../../../jiami/index.js";

export default {
  components: {
    identify
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    this.query_config();
    if (this.$route.query.Type == "censor") {
      this.title = "建设单位网上报审";
      this.imgUrl = require("../../../assets/constractor_logo1.png");
      // this.imgBackground = require("../../../assets/jsdw.jpg");
    } else if (this.$route.query.Type == "survey") {
      this.title = "勘察单位网上报审";
      this.imgUrl = require("../../../assets/constractor_logo4.png");
      // this.imgBackground = require("../../../assets/kc.png");
    } else if (this.$route.query.Type == "design") {
      this.title = "设计单位网上报审";
      // this.imgBackground = require("../../../assets/sj.png");
    }
    
    document
      .querySelector("body")
      .setAttribute(
        "style",
        "background-image:url(" +
          require("../../../assets/bg-index.png") +
          ");background-size: cover;background-position: center bottom;background-repeat: no-repeat;background-attachment: fixed;"
      );
  },
  data() {
    var checkpass = (rule, value, callback) => {
      if (this.reset.checkpassword3 === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.reset.checkpassword !== this.reset.data.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var pass = (rule, value, callback) => {
      var tt = /^(?=^.{8,}$)(?=(?:.*?\d){1})(?=.*[a-z])(?=(?:.*?[A-Z]){1})(?=(?:.*?[@#$&.]){1})(?!.*\s)[0-9a-zA-Z@#$&\.]*$/; //不能全是数学和特殊字符.
      if (this.reset.data.password === "") {
        callback(new Error("请输入密码"));
      } else if (!tt.test(this.reset.data.password)) {
        callback(
          new Error(
            "密码必须是 大写字母，小写字母，特殊字符(包含 . @ # $ & )、数字 等其中任意四种类型或四种类型以上组合，且不能少于8位"
          )
        );
      } else {
        callback();
      }
    };
    var phone = (rule, value, callback) => {
      var reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
      if (this.reset.data.contactPersonTel == "") {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(this.reset.data.contactPersonTel)) {
        callback(new Error("手机格式不正确"));
      } else {
        callback();
      }
    };
    return {
      SubjectName: "", //CA证书通用名
      CertNumber: "", //CA证书编号
      identifyCodes: "1234567890",
      identifyCode: "",
      title: "", // 登录页面的title
      imgUrl: "", //图标上传
      imgBackground: "", //背景图
      upload: "/censor/att/upload",
      loading: false,
      loginAccount: true,
      Active1: true,
      Active2: true,
      isActive1: false,
      isActive2: false,
      CA: false,
      login: {
        username: "",
        password: "",
        // type: '建设单位',
        identifyCode: ""
      },
      loginPlaceholder: "组织机构代码",
      reset: {
        title: "",
        visible: false,
        checkpassword: "",
        data: {
          organizationCode: "",
          contactPersonTel: "",
          password: "",
          verificationCode: ""
        },
        loading: true,
        rules: {
          organizationCode: [
            {
              required: true,
              message: "请输入组织机构代码",
              trigger: "blur"
            }
          ],
          checkPass: [
            {
              validator: checkpass,
              trigger: "blur"
            }
          ],
          passwd: [
            {
              validator: pass,
              trigger: "blur"
            }
          ],
          phone: [
            {
              validator: phone,
              trigger: "blur"
            }
          ]
        }
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入您的用户名",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入您的密码",
            trigger: "blur"
          }
        ],
        verification: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ]
      },
      urlDrective: "",
      url: {
        login: "/censor/login",
        censor: "/censor/login",
        design: "/design/login",
        draw: "/draw/login",
        ca_login: "/censor/calogin/login",
        design_login: "/design/calogin/login",
        smsCensor: "/censor/sms/send2",
        smsDesign: "/design/sms/send2",
        sysFunctionsIntroduce: "/draw/sysFunctionsIntroduce",
        censor_reset_password: "/censor/constructioncorp/password",
        design_reset_password: "/design/designcorp/password",
        reset_password: "/censor/constructioncorp/password"
      },
      count_down: 0, //倒计时
      reg: false,
      socket: null,
      pluginRequestID: 0,
      certID: "",
      CertStr: "",
      CertData: ""
    };
  },
  created() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
    } else {
      this.connect();
    }
  },
  destroyed() {
    this.socket.close(); //离开路由之后断开websocket连接
  },
  computed: {
    regphone() {
      let reg = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      if (reg.test(this.reset.data.contactPersonTel)) {
        return false;
      } else {
        return true;
      }
    },
    mon_count() {
      if (this.count_down === 0) {
        return false;
      } else {
        setTimeout(() => {
          if (this.count_down > 0) {
            this.count_down = this.count_down - 1;
          }
        }, 1000);
        return true;
      }
    }
  },
  methods: {
    //背景图片
    query_config() {
      // document
      //   .querySelector("body")
      //   .setAttribute(
      //     "style",
      //     " background-image:url(../../../../../assets/.png);background-size: 100% 140%; background-repeat: no-repeat;"
      //   );

      // this.$http.get(
      //  this.url.sysFunctionsIntroduce+"?code=login_bg"
      // ).then((res) => {
      // });
    },
    accountlogin() {
      this.loginAccount = true;
      this.CA = false;
      if ((this.loginAccount = true)) {
        this.$refs.yonghu.style.color = "#409EFF";
        this.$refs.ca.style.color = "#999";
        this.$refs.yonghu.style.backgroundColor = "#fff";
        this.$refs.ca.style.backgroundColor = "#e1e3e7";
      }
    },
    CAlogin() {
      this.CA = true;
      this.loginAccount = false;
      if ((this.CA = true)) {
        this.$refs.yonghu.style.color = "#999";
        this.$refs.ca.style.color = "#409EFF";
        this.$refs.ca.style.backgroundColor = "#fff";
        this.$refs.yonghu.style.backgroundColor = "#e1e3e7";
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    guidance() {
      let routeUrl = this.$router.resolve({
        path: "/guidance"
      });
      window.open(routeUrl.href, "_blank");
    },
    question() {
      let routeUrl = this.$router.resolve({
        path: "/question"
      });
      window.open(routeUrl.href, "_blank");
    },
    video() {
      let routeUrl = this.$router.resolve({
        path: "/video"
      });
      window.open(routeUrl.href, "_blank");
    },
    handbook() {
      let routeUrl = this.$router.resolve({
        path: "/handbook"
      });
      window.open(routeUrl.href, "_blank");
    },
    //下载文件
    download_template1() {
      const link = document.createElement("a");
      link.href = "upload" + "/file/flowChart.pdf";
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
    },
    download_template2() {
      const link = document.createElement("a");
      link.href = "upload" + "file/operation.pdf"; //操作手册
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
    },
    guidance() {
      let routeUrl = this.$router.resolve({
        path: "/guidance"
      });
      window.open(routeUrl.href, "_blank");
    },
    question() {
      let routeUrl = this.$router.resolve({
        path: "/question"
      });
      window.open(routeUrl.href, "_blank");
    },
    //参考视频
    videoclick() {
      let routeUrl = this.$router.resolve({
        path: "/video"
      });
      window.open(routeUrl.href, "_blank");
    },
    keyupSubmit() {
      document.onkeydown = e => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.submit();
        }
      };
    },
    reset_close() {
      this.reset.visible = false;
      this.$refs.resetRef.resetFields();
      this.reset.data = {
        organizationCode: "",
        contactPersonTel: "",
        password: ""
      };
      this.checkpassword = "";
    },
    show_reset_password() {
      // this.reset.visible = true;
      // if (this.$route.query.Type === "censor") {
      //   this.reset.title = "建设单位修改密码";
      //   this.url.reset_password = this.url.reset_password;
      // } else if (this.$route.query.Type === "survey") {
      //   this.reset.title = "勘察单位修改密码";
      //   this.url.reset_password = this.url.design_reset_password;
      // } else if (this.$route.query.Type === "design") {
      //   this.reset.title = "设计单位修改密码";
      //   this.url.reset_password = this.url.design_reset_password;
      // }
      if (this.$route.query.Type === "censor") {
        this.$router.push({name:"constructionforgetpassword",query:{
          type:'censor',
        }});
      } else if (this.$route.query.Type === "survey") {
        this.$router.push({name:"constructionforgetpassword",query:{
          type:'survey',
        }});
      } else if (this.$route.query.Type === "design") {
        this.$router.push({name:"constructionforgetpassword",query:{
          type:'design',
        }});
      }
    },
    reset_submit() {
      this.$refs.resetRef.validate(valid => {
        if (valid) {
          this.loading = true;
          //post请求
          this.reset.data.password = cryptoObj.encryptFunc(
            this.reset.data.password,
            "1234567890123456"
          );
          this.$http
            .post(this.url.reset_password, this.reset.data)
            .then(res => {
              this.loading = false;
              if (res.body.status == "200") {
                this.$message.success("修改密码成功，请重新登录");
                this.reset_close();
              } else {
                this.loading = false;
                this.$message.error(res.body.message);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    auth_code() {
      //验证码
      this.count_down = 60;
      let data = { mobile: this.reset.data.contactPersonTel };
      if (this.$route.query.Type === "censor") {
        this.url.sms = this.url.smsCensor;
      } else if (
        this.$route.query.Type === "survey" ||
        this.$route.query.Type === "design"
      ) {
        this.url.sms = this.url.smsDesign;
      }
      this.$http.post(this.url.sms, data, { emulateJSON: true }).then(
        res => {
          if (res.status == 200) {
            this.$message.success("发送成功");
          } else {
            this.count_down = 0;
            this.$message.error("发送失败");
          }
        },
        err => {
          this.count_down = 0;
          this.$message.error("发送失败");
        }
      );
    },
    radioChange(type) {
      this.reg = false;
      if (this.$route.query.Type === "censor") {
        this.loginPlaceholder = "组织机构代码";
        this.title = "建设单位网上报审";
        this.reset.title = "建设单位修改密码";
        this.url.login = this.url.censor;
        this.url.reset_password = this.url.censor_reset_password;
      } else if (
        this.$route.query.Type === "survey" ||
        this.$route.query.Type === "design"
      ) {
        this.loginPlaceholder = "组织机构代码（公司）/手机号（个人））";
        this.title = "勘察/设计单位网上报审";
        this.url.login = this.url.design;
        this.reset.title = "勘察/设计单位修改密码";
        this.url.reset_password = this.url.censor_reset_password;
      } else if (this.$route.query.Type === "drawing") {
        this.loginPlaceholder = "用户名";
        this.title = "审查机构";
        this.reset.title = "审查机构修改密码";
        this.url.login = this.url.draw;
        this.reg = true;
        this.url.reset_password = this.url.censor_reset_password;
      } else if (this.$route.query.Type === "supervise") {
        this.loginPlaceholder = "用户名";
        this.title = "监管中心";
        this.reset.title = "监管中心修改密码";
        this.url.login = this.url.draw;
        this.reg = true;
        this.url.reset_password = this.url.censor_reset_password;
      }
    },
    register() {
      if (this.$route.query.Type === "censor") {
        this.$router.push({ name: "constructionRegister" });
      } else if (this.$route.query.Type === "survey") {
        this.$router.push({ name: "designRegister2" });
      } else if (this.$route.query.Type === "design") {
        this.$router.push({ name: "designRegister" });
      }
    },
    submit() {
      if (this.$route.query.Type === "censor") {
        this.urlDrective = this.url.login;
      } else if (
        this.$route.query.Type === "survey" ||
        this.$route.query.Type === "design"
      ) {
        this.urlDrective = this.url.design;
      }
      // this.urlDrective
      this.$refs.loginRef.validate(valid => {
        if (valid) {
          if (this.login.verification != this.identifyCode) {
            this.refreshCode();
            this.login.verification = "";
            this.$message.error("请输入正确的验证码");
            return;
          }
          this.loading = true;
          //post请求
          this.$http.post(
            this.urlDrective,
            {
              //后续放开
              username: cryptoObj.encryptFunc(
                this.login.username,
                "1234567890123456"
              ),
              password: cryptoObj.encryptFunc(
                this.login.password,
                "1234567890123456"
              ),
              // username: this.login.username,
              // password: this.login.password,
              identifyCode: this.login.identifyCode,
              verification: this.login.verification
            },
            { emulateJSON: true }
          )
            .then(res => {
              this.loading = false;
              if (res.data.status == "200") {
                // var tt = /^(?=^.{8,}$)(?=(?:.*?\d){1})(?=.*[a-z])(?=(?:.*?[A-Z]){1})(?=(?:.*?[@#$&.]){1})(?!.*\s)[0-9a-zA-Z@#$&\.]*$/;
                // if (!tt.test(this.login.password)) {
                //   this.$message.warning("系统检测到登录密码强度很弱，请立即对密码进行修改，提高密码强度！");
                //    if (this.$route.query.Type === "censor") {
                //     this.$router.push({name:"constructionforgetpassword",query:{
                //     type:'censor',
                //     }});
                //   } else if (this.$route.query.Type === "survey") {
                //     this.$router.push({name:"constructionforgetpassword",query:{
                //       type:'survey',
                //     }});
                //   } else if (this.$route.query.Type === "design") {
                //     this.$router.push({name:"constructionforgetpassword",query:{
                //       type:'design',
                //     }});
                //   }
                // }else{
                  this.$message.success("登录成功，欢迎回来");
                   document
                  .querySelector("body")
                  .setAttribute("style", "background-image:url()");
                this.$store.commit("$_setStorage", { user: res.body });
                //sessionStorage.setItem("loginName", "苏州市区建设有限公司");
                if (this.$route.query.Type === "censor") {
                  this.$store.commit("$_setLogin", "100");
                  this.$store.commit("$_setDraw", "建设单位网上报审");
                  this.$router.push("/constructionHome");
                } else if (this.$route.query.Type === "survey") {
                  this.$store.commit("$_setLogin", "200");
                  this.$store.commit("$_setDraw", "勘察单位网上报审");
                  this.$router.push("/designHome");
                } else if (this.$route.query.Type === "design") {
                  this.$store.commit("$_setLogin", "200");
                  this.$store.commit("$_setDraw", "设计单位网上报审");
                  this.$router.push("/designHome");
                }
                // }
              } else {
                this.loading = false;
                this.refreshCode();
                this.login.verification = "";
                this.$message.error(res.body.message);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submit_ca() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        this.ca_login_IE();
      } else {
        // do not IE something
        this.login_ca_other();
      }
    },
    ca_login_IE() {
      var textCertID = "";
      var textCert = "";
      var random = "";
      //生成随机数
      for (var i = 0; i < 10; i++) {
        random += parseInt(Math.ceil(Math.random() * 10));
      }
      //登录
      var ca_login = this.$refs.obj.SOF_Login("", "");
      if (ca_login != 0) {
        this.$message.error("出现错误，请重试！");
        return;
      }
      //获取用户列表
      var ca_userList = this.$refs.obj.SOF_GetUserList();
      if (ca_userList == "") {
        this.$message.error("出现错误，请重试！");
        return;
      }
      var len = ca_userList.length;
      var len2 = "38";
      var str2 = ca_userList.substr(len - len2, len2);
      textCertID = str2;
      //获取签名证书
      var ca_cert = this.$refs.obj.SOF_ExportUserCert(textCertID);
      if (ca_cert == "") {
        this.$message.error("出现错误，请重试！");
        return;
      }
      textCert = ca_cert;
      var ca_sign = this.$refs.obj.SOF_SignData(textCertID, random);
      if (ca_sign == "") {
        this.$message.error("出现错误，请重试！");
        return;
      }
      textCertID = ca_sign;
      this.CertData = random;
      this.CertStr = textCert;
      this.CertID = textCertID;
      var cn = obj.SOF_GetCertInfo(textCert, 0x00000017); //用户名
      var sn = obj.SOF_GetCertInfo(textCert, 0x00000002); //序列号
      this.ca_login_submit();
    },
    ca_login_submit() {
      if (this.$route.query.Type === "censor") {
        this.urlDrective = this.url.login;
        this.$http
          .post(
            this.url.ca_login,
            { subjectName: this.SubjectName, certNumber: this.CertNumber },
            { emulateJSON: true }
          )
          .then(res => {
            if (res.data.status == "200") {
              this.$message.success("登录成功");
              this.$store.commit("$_setStorage", {
                user: JSON.parse(res.body.result)
              });
              if (this.$route.query.Type === "censor") {
                this.$store.commit("$_setLogin", "100");
                this.$store.commit("$_setDraw", "建设单位网上报审");
                this.$router.push("/constructionHome");
              } else if (this.$route.query.Type === "survey") {
                this.$store.commit("$_setLogin", "200");
                this.$store.commit("$_setDraw", "勘察单位网上报审");
                this.$router.push("/designHome");
              } else if (this.$route.query.Type === "design") {
                this.$store.commit("$_setLogin", "200");
                this.$store.commit("$_setDraw", "设计单位网上报审");
                this.$router.push("/designHome");
              }
            } else {
              this.loading = false;
              this.$message.error(res.body.message);
            }
          });
      } else if (
        this.$route.query.Type === "survey" ||
        this.$route.query.Type === "design"
      ) {
        this.urlDrective = this.url.design;
        this.$http
          .post(
            this.url.design_login,
            { subjectName: this.SubjectName, certNumber: this.CertNumber },
            { emulateJSON: true }
          )
          .then(res => {
            if (res.data.status == "200") {
              this.$message.success("登录成功");
              this.$store.commit("$_setStorage", {
                user: JSON.parse(res.body.result)
              });
              if (this.$route.query.Type === "censor") {
                this.$store.commit("$_setLogin", "100");
                this.$store.commit("$_setDraw", "建设单位网上报审");
                this.$router.push("/constructionHome");
              } else if (this.$route.query.Type === "survey") {
                this.$store.commit("$_setLogin", "200");
                this.$store.commit("$_setDraw", "勘察单位网上报审");
                this.$router.push("/designHome");
              } else if (this.$route.query.Type === "design") {
                this.$store.commit("$_setLogin", "200");
                this.$store.commit("$_setDraw", "设计单位网上报审");
                this.$router.push("/designHome");
              }
            } else {
              this.loading = false;
              this.$message.error(res.body.message);
            }
          });
      }

      this.loading = false;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
    },
    websocketonerror() {
      //连接建立失败重连
    },
    websocketonmessage(msg) {
      //数据接收
      if (msg) {
        if (typeof msg.data == "string") {
          this.dealWithResponseMessage(msg.data);
        } else {
          this.$message.error("出现错误请重试");
        }
      }
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
    },
    connect() {
      var host = "ws://127.0.0.1:31212/";
      this.socket = new WebSocket(host);
      this.socket.onopen = this.websocketonopen;
      this.socket.onmessage = this.websocketonmessage;
      this.socket.onclose = this.websocketclose;
      this.socket.onerror = this.websocketonerror;
      return true;
    },
    dealWithResponseMessage(respMessage) {
      // 响应消息
      var resp = JSON.parse(respMessage);
      if (resp.PluginResponseValue.length > 0) {
        var textOut = resp.PluginResponseValue;

        if (resp.PluginRequest == "SOF_GetUserList") {
          var str = resp.PluginResponseValue;
          var len = str.length;
          var len2 = 38;
          if (len > len2) {
            var str3 = str.substr(len - len2, len2);
            this.CertID = str3;
            this.onExportUserCert();
          }
        } else if (
          resp.PluginRequest == "SOF_ExportUserCert" ||
          resp.PluginRequest == "SOF_ExportExChangeUserCert"
        ) {
          this.CertStr = resp.PluginResponseValue;
          this.onGetCertInfo_sn();
        } else if (this.ca_type === "sn") {
          var sn = resp.PluginResponseValue;
          this.CertNumber = sn;
          this.onGetCertInfo_cn();
        } else if (this.ca_type === "cn") {
          var cn = resp.PluginResponseValue;
          this.SubjectName = cn;
          this.ca_login_submit();
        }
      } else {
        if (
          (resp.PluginRequest == "SOF_Login") &
          (resp.PluginResponse == "成功")
        ) {
          this.onGetUserList();
        } else {
          textOut = resp.PluginResponse;
        }
      }
    },
    onLogin() {
      this.pluginRequestID++;
      var req = {
        PluginRequestID: this.pluginRequestID,
        PluginRequest: "SOF_Login",
        CertID: "",
        PassWd: ""
      };
      this.socket.send(JSON.stringify(req));
    },
    onGetUserList() {
      this.pluginRequestID++;
      var req = {
        PluginRequestID: this.pluginRequestID,
        PluginRequest: "SOF_GetUserList"
      };
      this.socket.send(JSON.stringify(req));
    },
    onExportUserCert() {
      this.pluginRequestID++;
      var req = {
        PluginRequestID: this.pluginRequestID,
        PluginRequest: "SOF_ExportUserCert",
        CertID: this.CertID
      };
      this.socket.send(JSON.stringify(req));
    },
    onGetCertInfo_sn() {
      this.ca_type = "sn";
      console.log("onGetCertInfo in testktsofws.html");
      this.pluginRequestID++;
      var req = {
        PluginRequestID: this.pluginRequestID,
        PluginRequest: "SOF_GetCertInfo",
        Cert: this.CertStr,
        Type: "0x00000002"
      };
      this.socket.send(JSON.stringify(req));
    },
    onGetCertInfo_cn() {
      this.ca_type = "cn";
      console.log("onGetCertInfo in testktsofws.html");
      this.pluginRequestID++;
      var req = {
        PluginRequestID: this.pluginRequestID,
        PluginRequest: "SOF_GetCertInfo",
        Cert: this.CertStr,
        Type: "0x00000017"
      };
      this.socket.send(JSON.stringify(req));
    },
    login_ca_other() {
      this.loading = true;
      this.onLogin();
    }
  }
};
</script>
<style>
@import '../../../styles/css/login.css';
</style>



// WEBPACK FOOTER //
// src/views/login/xuzhou/censor_login-xz.vue